export const setIsInitedinitiated = 'set/isInitedinitiated'
export const setError = 'set/error'
export const setLevel = 'set/level'
export const setTimer = 'set/timer'
export const setShuffleCount = 'set/shuffleCount'
export const setIsRouletteMode = 'set/isRouletteMode'
export const setIsEasyMode = 'set/isEasyMode'
export const setIsRunning = 'set/isRunning'
export const setIsLoading = 'set/isLoading'
export const setMicrobeRawList = 'set/microbeRawList'
export const setReadingInformations = 'set/readingInformations'

export const addFound = 'add/found'
export const addSelected = 'add/selected'
export const addFailure = 'add/failure'
export const addScore = 'add/score'

export const resetScore = 'reset/score'
export const resetFailures = 'reset/failures'
export const resetFound = 'reset/found'
export const resetSelecteds = 'reset/selecteds'
